export const CART_ACTION_TYPES = {
    SET_CART_ITEMS: 'cart/SET_CART_ITEMS',
    TOGGLE_CART: 'cart/TOGGLE_CART',
    SET_CART_COUNT: 'cart/SET_CART_COUNT',
    SET_CART_TOTAL: 'cart/SET_CART_TOTAL'
};